import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  CardBatchPanelStatusChanged,
  CardBatchSchemaChanged,
  ClearCardBatchSearch,
  CloseCardBatchSidenav,
  CreateBatchSizeChanged,
  CreateCardBatch,
  CreateCardBatchSuccess,
  CreateCardPrefixChanged,
  CreateCardTypeChanged,
  CreateMemberCategoryChanged,
  CreateRemarksChanged,
  CreateSchemaChanged,
  DownloadCardBatch,
  DownloadCardBatchFailed,
  DownloadCardBatchSuccess,
  GetCardTypesSuccess,
  GetMemberCategoriesSuccess,
  GetSchemasSuccess,
  OpenCardBatchSidenav,
  ResetCreateForm,
  SearchCardBatches,
  SearchCardBatchesFailed,
  SearchCardBatchesSuccess,
  SetSubmitted,
  StoreBatches,
} from '../actions/card-batches.actions';
import { CardBatchesSearchState } from '../models/card-batches.model';

const initialState: CardBatchesSearchState = {
  panelExpanded: true,
  loyaltySchemaId: null,
  sideNavOpen: false,
  hasSearched: false,
  batches: [],
  searching: false,
  schemas: [],
  createSchemaId: null,
  createMemberCategoryId: null,
  createCardType: null,
  createBatchSize: '',
  createCardPrefix: '',
  createRemarks: '',
  submitted: false,
  memberCategories: [],
  cardTypes: [],
  downloadingBatchId: null,
};

export const CardBatchesReducer = createReducer(
  initialState,

  on(ActiveComponentChanged, (state, { activeComponent }) => {
    // Only reset when leaving the card batches component
    if (activeComponent === 'CardBatchesComponent') return state;
    return {
      ...initialState,
      schemas: state.schemas,
      memberCategories: state.memberCategories,
      cardTypes: state.cardTypes,
    };
  }),

  on(CardBatchPanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),

  on(CardBatchSchemaChanged, (state, { loyaltySchemaId }) => ({
    ...state,
    loyaltySchemaId,
  })),

  on(ClearCardBatchSearch, (state) => ({
    ...state,
    loyaltySchemaId: null,
    batches: [],
    hasSearched: false,
  })),

  on(GetMemberCategoriesSuccess, (state, { memberCategories }) => ({
    ...state,
    memberCategories,
  })),

  on(GetSchemasSuccess, (state, { schemas }) => ({
    ...state,
    schemas,
  })),

  on(GetCardTypesSuccess, (state, { cardTypes }) => ({
    ...state,
    cardTypes,
  })),

  on(OpenCardBatchSidenav, (state) => ({
    ...state,
    sideNavOpen: true,
  })),

  on(CloseCardBatchSidenav, (state) => ({
    ...state,
    sideNavOpen: false,
    submitted: false,
  })),

  on(CreateSchemaChanged, (state, { schemaId }) => ({
    ...state,
    createSchemaId: schemaId,
  })),

  on(CreateMemberCategoryChanged, (state, { memberCategoryId }) => ({
    ...state,
    createMemberCategoryId: memberCategoryId,
  })),

  on(CreateCardTypeChanged, (state, { cardType }) => ({
    ...state,
    createCardType: cardType,
  })),

  on(CreateBatchSizeChanged, (state, { batchSize }) => ({
    ...state,
    createBatchSize: batchSize,
  })),

  on(CreateCardPrefixChanged, (state, { cardPrefix }) => ({
    ...state,
    createCardPrefix: cardPrefix,
  })),

  on(CreateRemarksChanged, (state, { remarks }) => ({
    ...state,
    createRemarks: remarks,
  })),

  on(SetSubmitted, (state) => ({
    ...state,
    submitted: true,
  })),

  on(ResetCreateForm, (state) => ({
    ...state,
    createSchemaId: null,
    createMemberCategoryId: null,
    createCardType: null,
    createBatchSize: '',
    createCardPrefix: '',
    createRemarks: '',
    submitted: false,
  })),

  on(StoreBatches, (state, { batches }) => ({
    ...state,
    batches,
    hasSearched: true,
    searching: false,
  })),

  on(CreateCardBatch, (state) => ({ ...state })),

  on(SearchCardBatches, (state) => ({
    ...state,
    searching: true,
    hasSearched: true,
    batches: [],
  })),

  on(SearchCardBatchesSuccess, (state, { batches }) => ({
    ...state,
    searching: false,
    batches,
  })),

  on(SearchCardBatchesFailed, (state) => ({
    ...state,
    searching: false,
  })),

  on(CreateCardBatchSuccess, (state) => ({
    ...state,
    sideNavOpen: false,
    submitted: false,
    createSchemaId: null,
    createMemberCategoryId: null,
    createCardType: null,
    createBatchSize: '',
    createCardPrefix: '',
    createRemarks: '',
  })),

  on(DownloadCardBatch, (state, { cardBatchId }) => ({
    ...state,
    downloadingBatchId: cardBatchId,
  })),

  on(DownloadCardBatchSuccess, DownloadCardBatchFailed, (state) => ({
    ...state,
    downloadingBatchId: null,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
